<template>
  <DsfRow ref="row" :gutter="gutter"  :overflow="overflow" :min-height="minHeight" :class="getCss">
    <slot></slot>
  </DsfRow>
  <!-- <el-row class="ds-control ds-row" :gutter="(isDesign?0:gutter)" :class="getCss">
    <el-col v-for="(slot, $index) in slots" :key="$index" :style="getStyle()" :md="size" :slot-name="slot.name">
      <slot :name="slot.name"></slot>
    </el-col>
  </el-row> -->
</template>
<script>

export default dsf.component({
  name: "DsfRow12",
  ctrlCaption: "一行两列",
  mixins: [$mixins.layout],
  props: {
    overflow:{
      type:String,
      default:"hidden"
    },
    minHeight: {
      type: String,
      default: "0"
    },
    gutter: {
      type: Number,
      default: 0
    },
    slots: {
      type: Array,
      default() {
        return [
          { name: 'default', controls: [] }
        ];
      }
    }
  },
  computed: {
    getCss() {
      return [
        ...this.$getClass(),
        this.isDesign ? '' : 'ds-no-padding'
      ]
    },
    cols(){
      return this.$refs.row.cols;
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    createDesignerColumns.call(this);
    // console.log(this.isDesign)
  },
  methods: {
  }
});
function createDesignerColumns() {
  if (this.isDesign) {
    if (this.slots[0].controls.length == 0) {
      let size = 2
      for (let i = 0; i < size; i++) {
        let span = 24 / size;
        let obj = {
          'height': 'auto',
          'span': span
        }
        this.slots[0].controls.push(dsf.designer.createComponent('dsf.col', obj));
      }
    }
  }
}
</script>
